// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Route, Routes } from "react-router-dom";

import { NotFound } from "~@jii/common-ui";
import { EGT, UsTnMoreInformation } from "~@jii/paths";

import { UsTnSingleResidentDataContext } from "../components/UsTnSingleResidentDataContext/DataContext";
import { PageMoreInfoAbout } from "../pages/PageMoreInfoAbout";
import { PageMoreInfoCreditReports } from "../pages/PageMoreInfoCreditReports";
import { PageMoreInfoImportantDates } from "../pages/PageMoreInfoImportantDates";
import { PageUsTnAllMonthsCreditReport } from "../pages/PageUsTnAllMonthsCreditReport";
import { PageUsTnMonthlyReport } from "../pages/PageUsTnMonthlyReport";
import { PageUsTnResidentHome } from "../pages/PageUsTnResidentHome";

export function UsTnRouter() {
  return (
    <UsTnSingleResidentDataContext>
      <Routes>
        <Route index element={<PageUsTnResidentHome />} />
        <Route path="*" element={<NotFound />} />
        <Route
          path={UsTnMoreInformation.About.path}
          element={<PageMoreInfoAbout />}
        />
        <Route
          path={UsTnMoreInformation.ImportantDates.path}
          element={<PageMoreInfoImportantDates />}
        />
        <Route
          path={UsTnMoreInformation.Credits.path}
          element={<PageMoreInfoCreditReports />}
        />
        <Route
          path={EGT.AllMonths.path}
          element={<PageUsTnAllMonthsCreditReport />}
        />
        <Route
          path={EGT.MonthlyReport.path}
          element={<PageUsTnMonthlyReport />}
        />
      </Routes>
    </UsTnSingleResidentDataContext>
  );
}
